import * as CONSTANTS from "../utils/constants/constants";

class JournalService {
  
  static async registerTraining (access_token: string, user_id: string, organization_id: string, patientId: string, timestamp: string, override: boolean = false) {
    const url = CONSTANTS.HOST + "api/v1/rpm/journalentry/";

    const data = {
      "patient_id"       : patientId,
      "organization_id"  : organization_id,
      "source"           : "Clinician",
      "recorded_at"      : timestamp,
      "entry_type"       : "training",
      "override"         : override,
    }

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + access_token
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error(`Error registering training: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to register training:", error);
      return null;
    }

  }

  static async getTrainingRecords (access_token: string, patientId: string, organization_id: string, ) {
    const url = CONSTANTS.HOST + `api/v1/rpm/journalentry/?patient_id=${patientId}&organization_id=${organization_id}&entry_type=training`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + access_token
        },
      });

      if (!response.ok) {
        throw new Error(`Error fetching training records: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to fetch training records:", error);
      return null;
    }
  }

}

export default JournalService;
